/**
 * 气泡箭头位置计算
 */
function getArrowPadding(option) {
  var threshold = option.threshold,
    slotHalf = option.slotHalf,
    bubbleHalf = option.bubbleHalf,
    mode = option.mode;
  var offset = mode === 'vertical' ? -5 : 0;
  if (slotHalf <= threshold) {
    return threshold;
  } else if (slotHalf >= bubbleHalf) {
    return bubbleHalf + offset;
  }
  return slotHalf + offset;
}
function computeBubblePosition(option) {
  var bubbleVMPositionTemp = option.bubbleVMPositionTemp,
    position = option.position,
    positionOffset = option.positionOffset,
    slotElRect = option.slotElRect,
    bubbleElRect = option.bubbleElRect,
    arrowHorizontalThreshold = option.arrowHorizontalThreshold,
    arrowVerticalThreshold = option.arrowVerticalThreshold;
  var horizontalSmallerThanThreshold = slotElRect.width < 2 * arrowHorizontalThreshold; // 半宽小于threshold
  var verticalSmallerThanThreshold = slotElRect.height < 2 * arrowVerticalThreshold; // 半高小于threshold
  var x = bubbleVMPositionTemp.x,
    y = bubbleVMPositionTemp.y;
  var smallerThanThresholdOffset = 0; // 小于threshold时，气泡框的偏移量
  switch (position) {
    case 'left':
      y += (slotElRect.height - bubbleElRect.height) / 2;
      x -= bubbleElRect.width + positionOffset;
      break;
    case 'left-start':
      x -= bubbleElRect.width + positionOffset;
      if (verticalSmallerThanThreshold) {
        smallerThanThresholdOffset = arrowVerticalThreshold - slotElRect.height / 2 + 5;
      }
      y -= smallerThanThresholdOffset;
      break;
    case 'left-end':
      if (verticalSmallerThanThreshold) {
        smallerThanThresholdOffset = arrowVerticalThreshold - slotElRect.height / 2 + 5;
      }
      x -= bubbleElRect.width + positionOffset;
      y -= bubbleElRect.height - slotElRect.height - smallerThanThresholdOffset;
      break;
    case 'right':
      x += slotElRect.width + positionOffset;
      y += (slotElRect.height - bubbleElRect.height) / 2;
      break;
    case 'right-start':
      x += slotElRect.width + positionOffset;
      if (verticalSmallerThanThreshold) {
        smallerThanThresholdOffset = arrowVerticalThreshold - slotElRect.height / 2 + 5;
      }
      y -= smallerThanThresholdOffset;
      break;
    case 'right-end':
      x += slotElRect.width + positionOffset;
      if (verticalSmallerThanThreshold) {
        smallerThanThresholdOffset = arrowVerticalThreshold - slotElRect.height / 2 + 5;
      }
      y -= bubbleElRect.height - slotElRect.height - smallerThanThresholdOffset;
      break;
    case 'bottom':
      x += (slotElRect.width - bubbleElRect.width) / 2;
      y += slotElRect.height + positionOffset;
      break;
    case 'bottom-start':
      if (horizontalSmallerThanThreshold) {
        smallerThanThresholdOffset = arrowHorizontalThreshold - slotElRect.width / 2;
      }
      x -= smallerThanThresholdOffset;
      y += slotElRect.height + positionOffset;
      break;
    case 'bottom-end':
      if (horizontalSmallerThanThreshold) {
        smallerThanThresholdOffset = arrowHorizontalThreshold - slotElRect.width / 2;
      }
      x -= bubbleElRect.width - slotElRect.width - smallerThanThresholdOffset;
      y += slotElRect.height + positionOffset;
      break;
    case 'top-start':
      if (horizontalSmallerThanThreshold) {
        smallerThanThresholdOffset = arrowHorizontalThreshold - slotElRect.width / 2;
      }
      x -= smallerThanThresholdOffset;
      y -= bubbleElRect.height + positionOffset;
      break;
    case 'top-end':
      if (horizontalSmallerThanThreshold) {
        smallerThanThresholdOffset = arrowHorizontalThreshold - slotElRect.width / 2;
      }
      x -= bubbleElRect.width - slotElRect.width - smallerThanThresholdOffset;
      y -= bubbleElRect.height + positionOffset;
      break;
    default:
      x += (slotElRect.width - bubbleElRect.width) / 2;
      y -= bubbleElRect.height + positionOffset;
      break;
  }
  return {
    x: x,
    y: y
  };
}
/**
 * 气泡位置自适应
 */
// 位置定义
var positions = ['top', 'right', 'bottom', 'left', 'top-start', 'top-end', 'bottom-start', 'bottom-end', 'left-start', 'left-end', 'right-start', 'right-end'];
function remove(targetList, rmList) {
  for (var i in rmList) {
    var index = targetList.indexOf(rmList[i]);
    if (index > -1) {
      targetList.splice(index, 1);
    }
  }
  return targetList;
}
function prefer(targetList, pfList) {
  for (var i in pfList) {
    var index = targetList.indexOf(pfList[i]);
    if (index > -1) {
      targetList.splice(index, 1);
      targetList.push(pfList[i]);
    }
  }
  return targetList;
}
// 用于在开启位置自适应时，找到最佳渲染位置
function findBestBubblePosition(options) {
  var adaptiveRemainChanged = false;
  if (options.bubbleRect.top < options.adaptiveContainerRect.top) {
    options.adaptiveRemain = options.adaptingPosition === 'left' ? prefer(options.adaptiveRemain, ['right-start', 'left-start']) : prefer(options.adaptiveRemain, ['left-start', 'right-start']);
    options.adaptiveRemain = options.adaptingPosition.startsWith('top') ? prefer(options.adaptiveRemain, [options.adaptingPosition.replace('top', 'bottom')]) : options.adaptiveRemain;
    options.adaptiveRemain = remove(options.adaptiveRemain, ['top', 'top-start', 'top-end', options.adaptingPosition]);
    adaptiveRemainChanged = true;
  }
  if (options.bubbleRect.bottom > options.adaptiveContainerRect.bottom) {
    options.adaptiveRemain = options.adaptingPosition === 'left' ? prefer(options.adaptiveRemain, ['right-end', 'left-end']) : prefer(options.adaptiveRemain, ['left-end', 'right-end']);
    options.adaptiveRemain = options.adaptingPosition.startsWith('bottom') ? prefer(options.adaptiveRemain, [options.adaptingPosition.replace('bottom', 'top')]) : options.adaptiveRemain;
    options.adaptiveRemain = remove(options.adaptiveRemain, ['bottom', 'bottom-start', 'bottom-end', options.adaptingPosition]);
    adaptiveRemainChanged = true;
  }
  if (options.bubbleRect.left < options.adaptiveContainerRect.left) {
    options.adaptiveRemain = options.adaptingPosition === 'top' ? prefer(options.adaptiveRemain, ['bottom-start', 'top-start']) : prefer(options.adaptiveRemain, ['top-start', 'bottom-start']);
    options.adaptiveRemain = options.adaptingPosition.startsWith('left') ? prefer(options.adaptiveRemain, [options.adaptingPosition.replace('left', 'right')]) : options.adaptiveRemain;
    options.adaptiveRemain = remove(options.adaptiveRemain, ['left', 'left-start', 'left-end', options.adaptingPosition]);
    adaptiveRemainChanged = true;
  }
  if (options.bubbleRect.right > options.adaptiveContainerRect.right) {
    options.adaptiveRemain = options.adaptingPosition === 'top' ? prefer(options.adaptiveRemain, ['bottom-end', 'top-end']) : prefer(options.adaptiveRemain, ['top-end', 'bottom-end']);
    options.adaptiveRemain = options.adaptingPosition.startsWith('right') ? prefer(options.adaptiveRemain, [options.adaptingPosition.replace('right', 'left')]) : options.adaptiveRemain;
    options.adaptiveRemain = remove(options.adaptiveRemain, ['right', 'right-start', 'right-end', options.adaptingPosition]);
    adaptiveRemainChanged = true;
  }
  if (options.adaptiveRemain.includes(options.adaptingPosition)) {
    return {
      adaptedPosition: options.adaptingPosition,
      adaptiveRemainChanged: adaptiveRemainChanged
    };
  } else if (options.adaptiveRemain.length > 0) {
    return {
      adaptedPosition: options.adaptiveRemain.slice(-1)[0],
      adaptiveRemainChanged: adaptiveRemainChanged
    };
  } else {
    return {
      adaptedPosition: options.preferPosition,
      adaptiveRemainChanged: adaptiveRemainChanged
    };
  }
}

export { computeBubblePosition, findBestBubblePosition, getArrowPadding, positions };
